import { v4 as uuidv4 } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/Polo_dress_jc5roYV9I.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648716781430",
    productBrand: "Souled store",
    productName: "Polo dress",
    categoryName: "Women",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.5,
    productPrice: 999,
    productActualPrice: 1599,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "http://www.ardene.com/on/demandware.static/-/Sites-master-catalog/default/dw36aa08d9/images/large/2A-AP31130-10-b876bbea-3955-4c67-9aaa-869044d8e6f5.jpg",
    productBrand: "Studio 51 Clothing Co.",
    productName: "High-neck top",
    categoryName: "Women",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 499,
    productActualPrice: 999,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/T-shirt_LAGrFAXl2.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718016502",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Women",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 5.0,
    productPrice: 399,
    productActualPrice: 859,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/Shirt_-xwNLCrEZ.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718015764",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Hoddie",
    categoryName: "Women",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 2.5,
    productPrice: 899,
    productActualPrice: 1999,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/Sweater_dress_B9BNWUJVy.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718015967",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweater dress",
    categoryName: "Women",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1499,
    productActualPrice: 2199,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/Sweat-Shirt.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718919888",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweat-shirt",
    categoryName: "Men",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1499,
    productActualPrice: 2999,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/Men_s_tai.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718940779",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Men's tie",
    categoryName: "Men",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 599,
    productActualPrice: 1999,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/61K5pmFuGaL._UY550_-removebg-preview_PRlhoYaSa.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718880923",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Men",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 1899,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/063fcb82-0dca-4c10-8173-4c6b88bc40d7.8d2068279e1fa41c2e2b8fabcd232253-removebg-preview__lKJjV_YP.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718880617",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Girl",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 999,
    productActualPrice: 1499,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/racerback_pj-removebg-preview_0deh8mMj2.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718879937",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night wear",
    categoryName: "Girl",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 1199,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/hmgoepprod-removebg-preview_ZwvUN8Ypi.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718879954",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Quidditch",
    categoryName: "Girl",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 599,
    productActualPrice: 789,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/_pdp_sq_-removebg-preview_w8NQyoW1FP.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718879195",
    productBrand: "Studio 51 Clothing Co.",
    productName: "School dress",
    categoryName: "Girl",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 1249,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/374aec7b-8f14-49ff-85f2-7b8f4e247032_1.6b1607228b45b6e74cff9f593b9f8030-removebg-preview_4z1ZOVgWn.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718878557",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night wear",
    categoryName: "Boy",
    productHouse: "Gryffindor",
    productStock: false,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 1139,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/image-removebg-preview__6__VG43y4pjK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718878776",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Cotton wear",
    categoryName: "Boy",
    productHouse: "Gryffindor",
    productStock: false,
    fastDelivery: false, 
    productRating: 3.0,
    productPrice: 299,
    productActualPrice: 1639,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Gryffindor/b9b4fa50a6ea81e6503db09544794196-removebg-preview_rOQof5Ah2.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648718878438",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night suit",
    categoryName: "Boy",
    productHouse: "Gryffindor",
    productStock: true,
    fastDelivery: false, 
    productRating: 3.0,
    productPrice: 549,
    productActualPrice: 729,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/Hufflepuff-removebg-preview_Ox7L9HyMF.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739328768",
    productBrand: "Allen solly",
    productName: "Sweat shirt",
    categoryName: "Women",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 999,
    productActualPrice: 1999,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/Harry-Potter-Tartan-Hufflepuff-Apron-Dress-removebg-preview_1FXzIQXdK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739328370",
    productBrand: "Peter England",
    productName: "One piece",
    categoryName: "Women",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 799,
    productActualPrice: 999,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/12051844_hi-removebg-preview_n1orhJi0s.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739325098",
    productBrand: "Allen solly",
    productName: "Over-sized T-shirt",
    categoryName: "Women",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 5.0,
    productPrice: 499,
    productActualPrice: 999,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/adult-harry-potter-hufflepuff-tie_13969363-removebg-preview_cMMUskiFOT.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739320121",
    productBrand: "Van Heusen",
    productName: "Hufflepuff tie",
    categoryName: "Women",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 2.0,
    productPrice: 299,
    productActualPrice: 799,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/images-removebg-preview__1__dJPP7uyL0.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739113696",
    productBrand: "Peter England",
    productName: "Hoddie",
    categoryName: "Women",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1499,
    productActualPrice: 2999,
    productAddedInMonths: 5,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/1544048529-10999515_hi-removebg-preview_RJTsNjtjv.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739170629",
    productBrand: "Flying Machine",
    productName: "Muffler",
    categoryName: "Men",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 599,
    productActualPrice: 899,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/61243eV0b9L._UY550_-removebg-preview_CeMR2wTCK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739169608",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweater",
    categoryName: "Men",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 1199,
    productActualPrice: 2199,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/55f5d19af694422fde6ead6c2cab8391-removebg-preview_hy7DH8CMd.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739142499",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Jacket",
    categoryName: "Men",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1299,
    productActualPrice: 1999,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/d2407b4f4d6bc7c1c27c2581166f3433-removebg-preview_qmZGlYg6R.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739169624",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Overcoat",
    categoryName: "Girl",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 999,
    productActualPrice: 1899,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/1fdbaeba9989acbde1e911897ce1933e-removebg-preview_yuyuBHKHR.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739157779",
    productBrand: "Peter England",
    productName: "Night wear",
    categoryName: "Girl",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 759,
    productActualPrice: 1269,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/zu73289357_main_tm1561572622-removebg-preview_W3zWWJvDl.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739156970",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night wear",
    categoryName: "Girl",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1199,
    productActualPrice: 2099,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/images-removebg-preview_nCqyq5JAQ.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739133215",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweater",
    categoryName: "Girl",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 899,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/9bf3c4cb-4afd-42f7-b499-a0256831b518_1.359a7856a28954b57811307b295c02da-removebg-preview_Xrq2M2LFET.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739169603",
    productBrand: "peter England",
    productName: "Night wear",
    categoryName: "Boy",
    productHouse: "Hufflepuff",
    productStock: false,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 1999,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/kids-tie-hufflepuff-removebg-preview_Uu8sdK0Pem.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739156306",
    productBrand: "Allen solly",
    productName: "Hufflepuff tai",
    categoryName: "Boy",
    productHouse: "Hufflepuff",
    productStock: false,
    fastDelivery: false, 
    productRating: 4.0,
    productPrice: 299,
    productActualPrice: 999,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Hufflepuff/8781513f-removebg-preview_eOciVrLlSh.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739147744",
    productBrand: "Studio 51 Clothing Co.",
    productName: "School costume",
    categoryName: "Boy",
    productHouse: "Hufflepuff",
    productStock: true,
    fastDelivery: false, 
    productRating: 3.0,
    productPrice: 999,
    productActualPrice: 1129,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/61JplBRrg7L._UY550_-removebg-preview_S_zVoAGBY.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739470502",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweater",
    categoryName: "Women",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 1499,
    productActualPrice: 2199,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/11946013_hi-removebg-preview_JZ4SedRuIL.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739469898",
    productBrand: "Allen solly",
    productName: "Sweater dress",
    categoryName: "Women",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 1199,
    productActualPrice: 1999,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/61tekQ1-_dL._UL1000_-removebg-preview_7OVl1r8iA.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739469246",
    productBrand: "Allen solly",
    productName: "Sweater",
    categoryName: "Women",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 5.0,
    productPrice: 899,
    productActualPrice: 1499,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/Dress_Blue-removebg-preview_LHdWtMWGR.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739469267",
    productBrand: "Flying machine",
    productName: "One piece",
    categoryName: "Women",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 2.0,
    productPrice: 1499,
    productActualPrice: 2499,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/c13257b660570bc31c242a38047387e3-removebg-preview_7lDI64Q_5.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739468494",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Women",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 729,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/images-removebg-preview_cEJn6FPtX.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739467299",
    productBrand: "Flying machine",
    productName: "Hoddie",
    categoryName: "Men",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 849,
    productActualPrice: 1299,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/x354-q80-removebg-preview_GHOmS8r3s.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739467426",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Men",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 499,
    productActualPrice: 599,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/61Sm36kd6FL._UX569_-removebg-preview_47HURm5ig.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739467773",
    productBrand: "Peter England",
    productName: "T-shirt",
    categoryName: "Men",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 2.0,
    productPrice: 399,
    productActualPrice: 1499,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/HP0397RGL_20-_20GIRL_20A_1800x-removebg-preview_89DgjLJCe.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739783640",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Dress",
    categoryName: "Girl",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 799,
    productActualPrice: 1299,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/53e4f9aa11ff8c8b7590bdf8e73e80d1-removebg-preview_wnaio_Xkn.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739739230",
    productBrand: "Allen solly",
    productName: "Night wear",
    categoryName: "Girl",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 999,
    productActualPrice: 1299,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/HPT00050GI14S253Front-removebg-preview_TbrQ7-t8h.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739739541",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Hoddie",
    categoryName: "Girl",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1199,
    productActualPrice: 2399,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/images-removebg-preview__1__CjjrYxs2h.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739738618",
    productBrand: "Peter England",
    productName: "Black Hoddie",
    categoryName: "Girl",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 799,
    productActualPrice: 1629,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/26f2e50202e74aaa134a95808a3c7e46-removebg-preview_0u8T1wh3oq.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739738648",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night wear",
    categoryName: "Boy",
    productHouse: "Ravenclaw",
    productStock: false,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 799,
    productActualPrice: 1429,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/81JECfm1ksL._UL1500_-removebg-preview_g7fiDYDzE.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739738174",
    productBrand: "Flying machine",
    productName: "Night wear",
    categoryName: "Boy",
    productHouse: "Ravenclaw",
    productStock: false,
    fastDelivery: false, 
    productRating: 4.0,
    productPrice: 799,
    productActualPrice: 2999,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Ravenclaw/GUEST_e566657d-08ec-4e4d-a3d2-4187d9ce3d3c-removebg-preview_2k3Mx7oaP.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648739735660",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Boy",
    productHouse: "Ravenclaw",
    productStock: true,
    fastDelivery: false, 
    productRating: 3.0,
    productPrice: 639,
    productActualPrice: 1299,
    productAddedInMonths: 3,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/JJTOSER21806-1-removebg-preview_nHzd2WUEqx.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286610",
    productBrand: "Peter England",
    productName: "Sweat-shirt",
    categoryName: "Women",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 1499,
    productActualPrice: 1999,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/085ec83d998b99795e873b1c6270d926-removebg-preview_lHCRaA5J5.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286469",
    productBrand: "Allen solly",
    productName: "T-shirt",
    categoryName: "Women",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 749,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/harry_potter_phone_case_1726-000035-9599_01l-removebg-preview_38FgOLFga.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810285667",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Sweat-shirt",
    categoryName: "Women",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 5.0,
    productPrice: 799,
    productActualPrice: 899,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/Harry-Potter-Tartan-Slytherin-Apron-Dress-removebg-preview_L0MwXj6Wd.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810285487",
    productBrand: "Flying machine",
    productName: "Dress",
    categoryName: "Women",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 1499,
    productActualPrice: 2189,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/black-harry-potter-slytherin-crest-t-shirt-removebg-preview_NRnjlvCP0.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810284875",
    productBrand: "Peter England",
    productName: "T-shirt",
    categoryName: "Women",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 999,
    productActualPrice: 1599,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/xs-164251-the-souled-store-original-imafy2evhgbfntha-removebg-preview_FQdmX7eLF.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286768",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Men",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 999,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/61KhlT0xPkL._UL1440_-removebg-preview_7gxV3QQGMs.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810285958",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Collared t-shirt",
    categoryName: "Men",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 499,
    productActualPrice: 599,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/612ZcHVDquL._UY550_-removebg-preview_uJ0xTFWzcH.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810285689",
    productBrand: "Studio 51 Clothing Co.",
    productName: "T-shirt",
    categoryName: "Men",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 299,
    productActualPrice: 999,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/498e1997-1376-4b2c-b387-21de3306e2f7.3ea7776f9e822e398ba025cf8790f811-removebg-preview_sxZqDrnDG.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286594",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Night suit",
    categoryName: "Girl",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 4.0,
    productPrice: 499,
    productActualPrice: 999,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/P1ZN-removebg-preview_uHKuIhqv4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810287821",
    productBrand: "Peter England",
    productName: "Slytherin tai",
    categoryName: "Girl",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 639,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/kids-harry-potter-slytherin-halloween-costume-c-removebg-preview_5lrng-jAD.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286924",
    productBrand: "Allen solly",
    productName: "Muffler",
    categoryName: "Girl",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 499,
    productActualPrice: 1219,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/toddler-harry-potter-slytherin-halloween-costume-o-removebg-preview_wGtB_6PXD4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286747",
    productBrand: "Studio 51 Clothing Co.",
    productName: "School costume",
    categoryName: "Girl",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 999,
    productActualPrice: 1579,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/4933d2f3488e6905360f8265e0c1bb50-removebg-preview_0fgu826Kjx.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810286058",
    productBrand: "Peter England",
    productName: "Night wear",
    categoryName: "Boy",
    productHouse: "Slytherin",
    productStock: false,
    fastDelivery: true, 
    productRating: 3.0,
    productPrice: 1299,
    productActualPrice: 1569,
    productAddedInMonths: 4,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/Necktie-Kids-Slytherin-HarryPotter-Product-_2-removebg-preview_1FB3CtBj0.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810288224",
    productBrand: "Studio 51 Clothing Co.",
    productName: "Slytherin tai",
    categoryName: "Boy",
    productHouse: "Slytherin",
    productStock: false,
    fastDelivery: false, 
    productRating: 3.0,
    productPrice: 299,
    productActualPrice: 459,
    productAddedInMonths: 2,
    productDesc: ["Relaxed Fit Hoddie"],
},
{
    _id: uuidv4(),
    productImg: "https://ik.imagekit.io/ecomdiagonalley/DiagonAlley/Slytherin/713n9vczsHL._UY550_-removebg-preview_ihxmmziz_.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648810287942",
    productBrand: "Flying machine",
    productName: "Overcoat",
    categoryName: "Boy",
    productHouse: "Slytherin",
    productStock: true,
    fastDelivery: false, 
    productRating: 4.0,
    productPrice: 1899,
    productActualPrice: 2599,
    productAddedInMonths: 1,
    productDesc: ["Relaxed Fit Hoddie"],
},
];